import { BrowserRouter, Routes, Route } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import LandingPageOld from './pages/LandingPageOld';
import ReportsLanding from './pages/ReportsLanding';
import ReportsLandingOld from './pages/ReportsLandingOld';
import AuditLanding from './pages/AuditLanding';
import AuditEvergreenLanding from './pages/AuditEvergreenLanding';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/old" element={<LandingPageOld />} />
        <Route path="/manazerske-reporty" element={<ReportsLanding />} />
        <Route path="/manazerske-reporty-old" element={<ReportsLandingOld />} />
        <Route path="/audit" element={<AuditLanding />} />
        <Route path="/digitalizacni-audit" element={<AuditEvergreenLanding />} />
      </Routes>
    </BrowserRouter>
  );
}
